import React from "react";

import { useTooltipController } from "./TooltipHost";

type TooltipTargetProps = {
  tooltip: (close: () => void) => React.ReactNode;
  children: React.ReactElement;
};

const OVERLAP_PX = 0;

export default function TooltipTarget(props: TooltipTargetProps) {
  const { tooltip, children } = props;
  const { showTooltip, hideTooltip, scheduleDelayedHide } = useTooltipController();

  function handleMouseEnter(ev: React.MouseEvent) {
    const rect = (ev.currentTarget as HTMLElement).getBoundingClientRect();
    showTooltip({
      x: rect.right - OVERLAP_PX,
      y: rect.top + rect.height / 2,
      content: tooltip(hideTooltip),
    });
  }

  function handleMouseLeave() {
    scheduleDelayedHide();
  }

  const childProps = children.props as Record<string, unknown>;
  return React.cloneElement(children, {
    onMouseEnter: (ev: React.MouseEvent) => {
      (childProps.onMouseEnter as ((ev: React.MouseEvent) => void) | undefined)?.(ev);
      handleMouseEnter(ev);
    },
    onMouseLeave: (ev: React.MouseEvent) => {
      (childProps.onMouseLeave as ((ev: React.MouseEvent) => void) | undefined)?.(ev);
      handleMouseLeave();
    },
  });
}
